import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  InputNumber,
  Row,
  Select,
  DatePicker,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Formik, Field, Form, FieldArray } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import momentGenerateConfig from "rc-picker/lib/generate/moment";
import backIcon from "../assets/icons/back.svg";
import axios from "axios";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import {
  createDharmshalaBooking,
  getAllRoomsByFloorId,
  getAvailableBuildingList,
  getDharmshalaFloorList,
  getRoomTypeList,
} from "../utility/commonApi";
import deleteIcon from "../assets/icons/deleteIcon.svg";
import Swal from "sweetalert2";
import { toast } from "react-toastify";



const CustomDatePicker = DatePicker.generatePicker(momentGenerateConfig);
const { Option } = Select;

const AutoFillChauka = ({ roomTypes, bookingCategory, setFieldValue, values }) => {
  useEffect(() => {
    if (bookingCategory === "chauka" && roomTypes.length > 0) {
      const chaukaType = roomTypes.find((t) => t.name.toLowerCase().includes("chauka"));
      if (chaukaType && values.rooms.length > 0 && values.rooms[0].roomTypeId !== chaukaType._id) {
        setFieldValue("rooms[0].roomTypeId", chaukaType._id);
        setFieldValue("rooms[0].amount", chaukaType.price || 0);
      }
    }
  }, [roomTypes, bookingCategory, setFieldValue, values.rooms[0]?.roomTypeId]);
  return null;
};

function AddAccommodation({ bookingCategory = "accommodation", isChaturmas = false }) {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.auth.user);
  const [roomTypes, setRoomTypes] = useState([]); // State to store dynamic room types from API

  // Fetch room types from API
  const { data } = useQuery({
    queryKey: ["roomTypes"],
    queryFn: () => getRoomTypeList(),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (data && data.data && data.data.results) {
      setRoomTypes(data.data.results); // Update state with fetched data
    }
  }, [data]);

  const handleRemoveRoom = async (values, index, remove) => {
    remove(index);
  };

  const initialValues = {
    fromDate: null,
    toDate: null,
    men: 0,
    women: 0,
    children: 0,
    rooms: [
      {
        roomTypeId: "",
        // roomTypeName: "",
        // building: "",
        // buildingName: "",
        // floor: "",
        // floorName: "",
        // roomId: "",
        amount: 0,
        // roomNumber: "",
      },
    ],
    guestName: userDetails?.name || "",
    mobileNumber: userDetails?.mobileNumber || "",
    email: userDetails?.email || "",
    idType: "",
    idNumber: userDetails?.idNumber || "",
  };

  const validationSchema = Yup.object({
    fromDate: Yup.date().required("From Date is required"),
    toDate: Yup.date()
      .min(Yup.ref("fromDate"), "To Date must be after From Date")
      .required("To Date is required"),
    rooms: Yup.array().of(
      Yup.object({
        roomTypeId: Yup.string().required("Room Type is required"),
        amount: Yup.number()
          .min(0, "Amount cannot be negative")
          .required("Amount is required"),
      })
    ),
    guestName: Yup.string().required("Guest Name is required"),
    mobileNumber: Yup.string().required("Mobile Number is required"),
    email: Yup.string()
      .email("Invalid Email Address")
      .required("Email is required"),
    idType: Yup.string().required("ID Type is required"),
    idNumber: Yup.string().required("ID Number is required"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    const bookingPayload = {
      startDate: values.fromDate
        ? moment(values.fromDate).format("DD-MM-YYYY")
        : null,
      endDate: values.toDate
        ? moment(values.toDate).format("DD-MM-YYYY")
        : null,
      idType: values.idType,
      idNumber: values.idNumber,
      guestCount: {
        men: values.men || 0,
        women: values.women || 0,
        children: values.children || 0,
      },
      rooms: values.rooms.map((room) => ({
        roomTypeId: room.roomTypeId,
        // roomTypeName: room.roomTypeName,
        // building: room.building,
        // buildingName: room.buildingName,
        // floor: room.floor,
        // floorName: room.floorName,
        // roomId: room.roomId,
        // roomNumber: room.roomNumber,
        amount: room.amount,
      })),
      userDetails: {
        name: values.guestName,
        email: values.email,
        mobileNumber: values.mobileNumber,
        idType: values.idType,
        idNumber: values.idNumber,
      },
      status: "requested",
      Mobile: values.mobileNumber,
      bookingId: "",
      SelectedUser: userDetails,
      bookingCategory: bookingCategory,
    };
    try {
      const response = await createDharmshalaBooking(bookingPayload);
      if (response.status) {
        Swal.fire({
          title: response.message,
          text: `Your booking ID: ${response?.data?.bookingId}`,
          icon: "success",
          confirmButtonText: "Go to Bookings",
        }).then(() => {
          if (isChaturmas) {
            if (bookingCategory === "chauka") {
              navigate("/home?page=bookings_chauka");
            } else {
              navigate("/home?page=bookings_aawas");
            }
          } else {
            navigate("/home?page=bookings");
          }
        });
        resetForm();
      }
      // history.push("/booking/info");
    } catch (error) {
      if (error.response?.status === 409) {
        toast.error("You have already booked a room for the specified dates.");
      } else {
        toast.error("Error creating booking. Please try again.");
      }
    }
    // Add API call to submit the form data
  };

  const handleBack = () => {
    navigate(`/home`);
  };

  const cardStyle = {
    marginBottom: 5,
    background: "#fff",
    boxShadow: "0 2px 8px #0000000d",
    border: "1px solid #eee",
    padding: 10,
  };

  const headerStyle = {
    fontWeight: 600,
    fontSize: "18px",
    color: "#333",
    background: "#fff",
    borderBottom: "1px solid #eee",
    marginBottom: "10px",
    paddingBottom: "5px"
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <img
            src={backIcon}
            className="me-2 cursor-pointer"
            style={{ cursor: 'pointer' }}
            width={30}
            height={30}
            onClick={handleBack}
            alt="Back"
          />
          <div style={{ fontWeight: 600, fontSize: "20px", color: "#ff8744" }}>
            {bookingCategory === "chauka" ? "Chauka Booking Form" : "Accommodation Form"}
          </div>
        </div>
      </div>

      <div style={{ height: "calc(100vh - 140px)", overflowY: "auto", paddingBottom: "100px", paddingRight: "10px" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange, setFieldValue }) => (
            <Form layout="vertical">
              <AutoFillChauka
                roomTypes={roomTypes}
                bookingCategory={bookingCategory}
                setFieldValue={setFieldValue}
                values={values}
              />

              <Row gutter={16}>
                <Col xs={24}>
                  <Card style={cardStyle} bordered={false} bodyStyle={{ padding: 0 }}>
                    <div style={headerStyle}>Booking Detail</div>
                    <Row gutter={16}>
                      <Col xs={24} sm={12} lg={6}>
                        <div className="d-flex flex-column mb-3">
                          <label htmlFor="fromDate" className="commonSmallFont mb-1">
                            From Date<span className="text-danger">*</span>
                          </label>
                          <CustomDatePicker
                            className="antdDatePickerComponent w-100"
                            id="fromDate"
                            name="fromDate"
                            format="DD MMM YYYY"
                            placeholder="Select Date"
                            value={values.fromDate}
                            onChange={(value) => {
                              setFieldValue("fromDate", value);
                            }}
                            disabledDate={(current) =>
                              current && current < moment().startOf("day")
                            }
                          />
                          {touched.fromDate && errors.fromDate && (
                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>{errors.fromDate}</div>
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={6}>
                        <div className="d-flex flex-column mb-3">
                          <label htmlFor="toDate" className="commonSmallFont mb-1">
                            To Date<span className="text-danger">*</span>
                          </label>
                          <CustomDatePicker
                            className="antdDatePickerComponent w-100"
                            id="toDate"
                            name="toDate"
                            format="DD MMM YYYY"
                            placeholder="Select Date"
                            value={values.toDate}
                            onChange={(value) => {
                              setFieldValue("toDate", value);
                            }}
                            disabledDate={(current) =>
                              current &&
                              (current < moment().startOf("day") ||
                                (values.fromDate &&
                                  current < moment(values.fromDate).startOf("day")))
                            }
                          />
                          {touched.toDate && errors.toDate && (
                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>{errors.toDate}</div>
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={24} lg={12}>
                        <div className="d-flex justify-content-start gap-4">
                          <div className="d-flex flex-column mb-3" style={{ flex: 1 }}>
                            <label htmlFor="men" className="commonSmallFont mb-1">Men</label>
                            <InputNumber
                              className="antInput"
                              id="men"
                              name="men"
                              placeholder="Men"
                              min={0}
                              value={values.men}
                              onChange={(value) => setFieldValue("men", value)}
                              style={{ width: '100%' }}
                            />
                          </div>
                          <div className="d-flex flex-column mb-3" style={{ flex: 1 }}>
                            <label htmlFor="women" className="commonSmallFont mb-1">Women</label>
                            <InputNumber
                              className="antInput"
                              id="women"
                              name="women"
                              placeholder="Women"
                              min={0}
                              value={values.women}
                              onChange={(value) => setFieldValue("women", value)}
                              style={{ width: '100%' }}
                            />
                          </div>
                          <div className="d-flex flex-column mb-3" style={{ flex: 1 }}>
                            <label htmlFor="children" className="commonSmallFont mb-1">Children</label>
                            <InputNumber
                              className="antInput"
                              id="children"
                              name="children"
                              placeholder="Children"
                              min={0}
                              value={values.children}
                              onChange={(value) => setFieldValue("children", value)}
                              style={{ width: '100%' }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>

                <Col xs={24}>
                  <Card style={cardStyle} bordered={false} bodyStyle={{ padding: 0 }}>
                    <div style={headerStyle}>Rooms Detail</div>
                    <FieldArray name="rooms">
                      {({ push, remove }) => (
                        <div>
                          {values.rooms.map((room, index) => (
                            <Row gutter={16} key={index} className="d-flex align-items-center mb-2">
                              <Col xs={24} sm={10} lg={6}>
                                <div className="d-flex flex-column mb-2">
                                  <label htmlFor={`rooms[${index}].roomTypeId`} className="commonSmallFont mb-1">
                                    Room Type<span className="text-danger">*</span>
                                  </label>
                                  <Select
                                    id={`rooms[${index}].roomTypeId`}
                                    name={`rooms[${index}].roomTypeId`}
                                    placeholder="Select Room Type"
                                    value={room.roomTypeId}
                                    disabled={bookingCategory === "chauka"}
                                    onChange={(value) => {
                                      const selectedRoomType = roomTypes.find((type) => type._id === value);
                                      setFieldValue(`rooms[${index}].roomTypeId`, value);
                                      setFieldValue(`rooms[${index}].amount`, selectedRoomType?.price || 0);
                                    }}
                                    className="w-100"
                                  >
                                    {roomTypes
                                      .filter((type) =>
                                        bookingCategory === "chauka" || !type.name.toLowerCase().includes("chauka")
                                      )
                                      .map((type) => (
                                        <Option key={type._id} value={type._id}>
                                          {type.name}
                                        </Option>
                                      ))}
                                  </Select>
                                </div>
                              </Col>
                              <Col xs={20} sm={10} lg={6}>
                                <div className="d-flex flex-column mb-2">
                                  <label htmlFor={`rooms[${index}].amount`} className="commonSmallFont mb-1">
                                    Amount
                                  </label>
                                  <Input
                                    className="antInput"
                                    id={`rooms[${index}].amount`}
                                    name={`rooms[${index}].amount`}
                                    type="number"
                                    value={room.amount}
                                    onChange={(e) => setFieldValue(`rooms[${index}].amount`, e.target.value)}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col xs={4} sm={4} lg={4} className="d-flex align-items-center mt-3">
                                {values.rooms.length > 1 && (
                                  <img
                                    width={24}
                                    height={24}
                                    onClick={() => handleRemoveRoom(values, index, remove)}
                                    src={deleteIcon}
                                    style={{ cursor: "pointer" }}
                                    alt="Delete"
                                  />
                                )}
                              </Col>
                            </Row>
                          ))}
                          <Button
                            type="dashed"
                            icon={<PlusOutlined />}
                            onClick={() => push({ roomTypeId: "", amount: 0 })}
                            style={{ marginTop: 8 }}
                          >
                            <span style={{ marginLeft: 5 }}>Add More Room</span>
                          </Button>
                        </div>
                      )}
                    </FieldArray>
                  </Card>
                </Col>

                <Col xs={24}>
                  <Card style={cardStyle} bordered={false} bodyStyle={{ padding: 0 }}>
                    <div style={headerStyle}>Guest Detail</div>
                    <Row gutter={16}>
                      <Col xs={24} sm={12} lg={8}>
                        <div className="d-flex flex-column mb-3">
                          <label htmlFor="guestName" className="commonSmallFont mb-1">
                            Guest Name<span className="text-danger">*</span>
                          </label>
                          <Input
                            className="antInput"
                            id="guestName"
                            name="guestName"
                            placeholder="Guest Name"
                            value={values.guestName}
                            onChange={handleChange}
                          />
                          {touched.guestName && errors.guestName && (
                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>{errors.guestName}</div>
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={8}>
                        <div className="d-flex flex-column mb-3">
                          <label htmlFor="mobileNumber" className="commonSmallFont mb-1">
                            Mobile Number<span className="text-danger">*</span>
                          </label>
                          <Input
                            className="antInput"
                            id="mobileNumber"
                            name="mobileNumber"
                            placeholder="Mobile Number"
                            value={values.mobileNumber}
                            onChange={handleChange}
                          />
                          {touched.mobileNumber && errors.mobileNumber && (
                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>{errors.mobileNumber}</div>
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={8}>
                        <div className="d-flex flex-column mb-3">
                          <label htmlFor="email" className="commonSmallFont mb-1">
                            Email Address<span className="text-danger">*</span>
                          </label>
                          <Input
                            className="antInput"
                            id="email"
                            name="email"
                            placeholder="Email Address"
                            value={values.email}
                            onChange={handleChange}
                          />
                          {touched.email && errors.email && (
                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>{errors.email}</div>
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={8}>
                        <div className="d-flex flex-column mb-3">
                          <label htmlFor="idType" className="commonSmallFont mb-1">
                            ID Type<span className="text-danger">*</span>
                          </label>
                          <Select
                            id="idType"
                            name="idType"
                            placeholder="Select ID Type"
                            value={values.idType}
                            onChange={(value) => setFieldValue("idType", value)}
                            className="w-100"
                          >
                            <Option value="aadhaar">Aadhaar</Option>
                            <Option value="passport">Passport</Option>
                            <Option value="voterid">Voter ID</Option>
                          </Select>
                          {touched.idType && errors.idType && (
                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>{errors.idType}</div>
                          )}
                        </div>
                      </Col>
                      <Col xs={24} sm={12} lg={8}>
                        <div className="d-flex flex-column mb-3">
                          <label htmlFor="idNumber" className="commonSmallFont mb-1">
                            ID Number<span className="text-danger">*</span>
                          </label>
                          <Input
                            className="antInput"
                            id="idNumber"
                            name="idNumber"
                            placeholder="ID Number"
                            value={values.idNumber}
                            onChange={handleChange}
                          />
                          {touched.idNumber && errors.idNumber && (
                            <div className="text-danger mt-1" style={{ fontSize: '12px' }}>{errors.idNumber}</div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>

              <div className="btn-Published" style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: '#fff',
                padding: '15px 410px',
                boxShadow: '0 -1px 10px 1px rgba(0,0,0,0.1)',
                display: 'flex',
                justifyContent: 'flex-end',
                zIndex: 1,
                margin: 0
              }}>
                <Button
                  htmlType="submit"
                  style={{
                    backgroundColor: "#ff8744",
                    borderColor: "#ff8744",
                    color: "#fff",
                    fontWeight: 500,
                    padding: "0 20px",
                    height: "38px",
                    marginRight: "60px" /* Moved just the button slightly left */
                  }}
                >
                  <span>Submit Booking</span>
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default AddAccommodation;
